import { NgModule, Component, Input, OnChanges} from '@angular/core';
import {CommonModule} from '@angular/common';

@Component({
    selector: 'app-read-more',
    styles: [`
        .rmtext {
           display:inline-block;
           font-size: 15px;
           line-height: 160%;
           color: #222;
           font-family: 'SF UI Text Regular';
           white-space: pre-wrap;
           margin-top: 12px;
        }
        .rmbutton{
            font-size: 12px;
            font-family: 'SF UI Text Regular';
            color: #03A9F4;
            cursor: pointer;
        }
    `],
    template: `
        <div class="rmtext" [innerHTML]="currentText"></div>
        <a class="rmbutton" style="color: #2196F3;font-family: 'SF UI Text Regular';display: block;font-size: 15px;" *ngIf="!hideToggle" (click)="toggleView()">Read {{isCollapsed? 'more':'less'}}</a>
    `
})

export class ReadMoreComponent implements OnChanges {
    @Input() text!: string;
    @Input() maxLength = 100;
    currentText!: string;
    hideToggle = true;

    public isCollapsed = true;
    toggleView() {
        this.isCollapsed = !this.isCollapsed;
        this.determineView();
    }
    determineView() {
        if (this.text.length <= this.maxLength) {
            this.currentText = this.text;
            this.isCollapsed = false;
            this.hideToggle = true;
            return;
        }
        this.hideToggle = false;
        if (this.isCollapsed == true) {
            this.currentText = this.text.substring(0, this.maxLength) + '...';
        } else if (this.isCollapsed == false)  {
            this.currentText = this.text;
        }

    }
    ngOnChanges() {
        this.determineView();
    }
}


@NgModule({
    imports: [CommonModule],
    exports: [ReadMoreComponent],
    declarations: [ReadMoreComponent]
})
export class ReadMoreModule { }
